<div *ngIf="!isVertical" class="k-divider" [ngClass]="{'dark-divider':isDark,'dark-light':isDarkLight}"
    [style]="'height: '+ forceHeight+';'">
</div>
<div *ngIf="isVertical" class="k-divider-vertical" [ngClass]="{'dark-divider':isDark,'dark-light':isDarkLight}"></div>